
import React from 'react';
import { PropBotsList } from '@/components/admin/prop-trading/PropBotsList';
import { PropBotStatsCards } from '@/components/admin/prop-trading/PropBotStatsCards';
import { useIsMobile } from '@/hooks/use-mobile';
import { cn } from '@/lib/utils';

const PropBotManagementPage = () => {
  const isMobile = useIsMobile();
  
  return (
    <div className="space-y-4 md:space-y-6">
      <div>
        <h1 className={cn("font-bold tracking-tight", isMobile ? "text-xl" : "text-2xl")}>
          Prop Trading Bots Management
        </h1>
        <p className="text-muted-foreground text-sm md:text-base">
          Manage your prop trading bots, add new ones or edit existing ones.
        </p>
      </div>
      
      {/* Stats Overview */}
      <PropBotStatsCards />
      
      <PropBotsList />
    </div>
  );
};

export default PropBotManagementPage;
